export default "__VITE_ASSET__1a6eab17__"